import { render, staticRenderFns } from "./InprogressCards.vue?vue&type=template&id=3966b396&scoped=true"
import script from "./InprogressCards.vue?vue&type=script&lang=js"
export * from "./InprogressCards.vue?vue&type=script&lang=js"
import style0 from "./InprogressCards.vue?vue&type=style&index=0&id=3966b396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3966b396",
  null
  
)

export default component.exports